<template>
    <div class="mt-1">
      <ValidationProvider v-if="condition"  :vid="validation_label" :name="validation_label" :rules="getRules" v-slot="{ errors }">
        <div class="upload-btn-wrapper">
          <button id="file-uploader-com" v-bind:class="{ btn_success: uploaded_file || !errors[0], btn_danger: !uploaded_file  && !!errors[0]  }" class="">Upload a file</button>
          <input accept=".doc, .jpg, .pdf, .jpeg, .png, .docx, .txt" @change="fileUploader($event)" type="file" name="myfile" @click="$refs.fileInput.value=null" ref="fileInput"/>
        </div>
        <vs-chip @click="onClickFileRemove" closable v-if="(condition && uploaded_file) || !!errors[0]" transparent :color="uploaded_file || !errors[0] ? 'dark' : 'danger'"  class="mt-4">
          <a target="_blank" style="text-decoration: none; color: #000000" :href="uploaded_file" >{{__nameSplitter(uploaded_file)}}</a>
        </vs-chip>
        <span style="display: none">{{uploaded_file}}</span>
      </ValidationProvider>
    </div>
</template>

<script>
  const SupplierRepository = RepositoryFactory.get('supplier');
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
      name: "file-uploader",
      props: {
        file: String,
        condition: {
          type: Boolean,
          default: null
        },
        required :{
          type: Boolean,
          default: true
        },
      },
    data() {
      return {
        validation_label: (Math.floor(Math.random() * 999999) + 1) + ' ',
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    computed: {
      uploaded_file: function () {
        return this.file
      },
      getRules: function () {
        return this.uploaded_file ? '' : 'file_required'
      }
    },
      methods: {
        onClickFileRemove() {
          this.uploaded_file = ''
          this.$emit('onClickFileRemove')
        },
        async fileUploader(event){
          await this.$vs.loading()
          try {
            const file = await event.target.files[0]
            let formData = new FormData();
            formData.append('file', file);
            const file_name =  (await SupplierRepository.uploadFile(formData)).data.data.file
            this.uploaded_file= file_name
            this.$emit('onSetFileName', file_name)
            this.$vs.loading.close()
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },

      }
  }
</script>

<style scoped>

</style>
